import {format, parseISO} from 'date-fns';

export function formatDateRange(startDateStr: string, endDateStr: string) {
  try {
    const startDate = parseISO(startDateStr);
    const endDate = parseISO(endDateStr);

    const formattedStart = format(startDate, 'yyyy-MM-dd');
    const formattedEnd = format(endDate, 'yyyy-MM-dd');

    return `${formattedStart} - ${formattedEnd}`;
  } catch (error) {
    return 'Invalid date format';
  }
}
